import { LOGIN_URL } from "@api/constants";
import React, { FC } from "react";

import Center from "@components/Center";

const HelpCenterLoginRequired: FC = () => {
  return (
    <Center cy="login-required">
      <p>
        Please <a href={LOGIN_URL}>sign in</a> to access the help center. If you do not have an account, you
        can <a href={LOGIN_URL + "?initialScreen=signUp"}>sign up here</a>.
      </p>
      <style jsx>{`
        a {
          font-weight: bold;
          text-decoration: underline;
        }
      `}</style>
    </Center>
  );
};

export default HelpCenterLoginRequired;
